import { render, staticRenderFns } from "./BucketGroup.vue?vue&type=template&id=395e4dce"
import script from "./BucketGroup.vue?vue&type=script&lang=js"
export * from "./BucketGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports